(() => {
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push((swat) => {
    if (!swat.evtLayer || swat.evtLayer.kdCartSyncBound) return;
    swat.evtLayer.kdCartSyncBound = true;
    const refreshCart = () => {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    };
    swat.evtLayer.addEventListener("sw:addedtocart", refreshCart);
    swat.evtLayer.addEventListener("sw:addedalltocart", refreshCart);
  });
})();
